import store from '@/store';
import ProductHelper from '@/helpers/productHelper';
import PaymentTypes from '@/models/PaymentTypes';

/**
 * Regras relacionadas a view de installments
 */
export class CreditCardInstallmentsViewRules {
    /**
     * Regra para exibir ou não a view de installments
     */
    static ShouldShow() {
        let showInstallmentsView = store.getters['recurrentPayment/isRecurringPayment'] == false;

        return showInstallmentsView;
    }
}

export class CreditCardViewRules {
    /**
     * Regra genérica para exibir ou não as views referentes a cartão de credito
     */
    static ShouldShow() {
        const isCreditCardPayment = store.state.payment.PaymentType == PaymentTypes.CREDIT_CARD;
        return isCreditCardPayment;
    }
}

/**
 * Rules related to the ChangePaymentType view.
 *
 * Should not render change payment type view when the payment
 * is recurring because all the recurring payments are credit card
 * based, so there is no need to the user to see this page.
 *
 * @see MainPage.vue
 * @export
 * @returns {bool} Bool that defines if the view is going to be rendered.
 */
export function shouldRenderPaymentTypeView() {
    return store.getters['recurrentPayment/isRecurringPayment'] == false;
}

/**
 * Rules related to all the shipping views.
 *
 * Should not render any shipping view when the payment is recurring.
 *
 * @export
 * @returns {bool} Bool that defines if the view is going to be rendered.
 */
export function shouldRenderShippingView() {

    return ProductHelper.productHasShipping();
}

export function shouldRenderIdentificationView() {
    if (!store.getters['dataOnFile/isDofEnabled']) return false;
    return store.getters['dataOnFile/isAuthenticated'] == false;
}

export function shouldRenderCheckOtpView() {
    if (!store.getters['dataOnFile/isDofEnabled']) return false;
    if (store.getters['dataOnFile/isDofGuest']) return false;
    return store.getters['dataOnFile/isAuthenticated'] == false;
}
